export default "__VITE_ASSET__$b9gECVm__"